import React from 'react';
import {t} from 'i18next';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import Button from '../../../../../incase-domain/components/button/Button';
import {usePlayerLabels} from '../../../../../hooks/usePlayerLabels';

interface ConfirmButtonProps {
    element: IElementQuestionnaire;
    onConfirm: () => void;
    disabled: boolean;
    disablePointerEvents?: boolean;
    answered?: boolean;
    device: DeviceType;
}

function ConfirmButton(props: ConfirmButtonProps): JSX.Element {
    const {element, onConfirm, disabled, disablePointerEvents, answered, device} = props;
    const getLabel = usePlayerLabels();

    if (device === DeviceType.MOBILE) {
        return <></>;
    }

    return (
        <Button
            className="c-questionLayout__confirmButton"
            variant={answered ? 'ghost' : 'solid'}
            color={element.isDebatable ? 'warning' : 'info'}
            size="md"
            leading={answered ? 'solar:check-read-linear' : undefined}
            onClick={onConfirm}
            dynamicSize
            disabled={disabled}
            disablePointerEvents={disablePointerEvents}
        >
            <span>
                {answered
                    ? getLabel('elements-question-done') || t('common.done')
                    : getLabel('elements-question-try') || t('common.confirm')}
            </span>
        </Button>
    );
}

export default ConfirmButton;
